import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { map } from "rxjs/operators";

@Injectable()
export class TcServices {
  private URL3 = AppSettings.API_ENDPOINT_V3;
  headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("authToken", localStorage.getItem("usertoken"));
  }

  fetchScheduledJobInfo() {
    const lang = "en";
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));

    // Adding `lang` as a query parameter
    const url = `${this.URL3}/get/tc/service/and/template/details?lang=${lang}`;

    return this.http.get(url, { headers }).pipe(map((res) => res));
  }

  tcJobCancel(jobId) {
    const lang = "en";
    const params = { lang: lang, jobDetailId: jobId };
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/cancel/scheduled/job`;
    return this.http.put(url, params,{headers }).pipe(map((res) => res));
  }


  uploadExcel(body, formData) {
    const form = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty(key)) {
        form.append(key, body[key]);
      }
    }
    form.append("tcExcel", formData, formData.name); 
    const headers = new HttpHeaders()
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/upload/excel/for/tc/generation`;
    return this.http.post(url, form, { headers }).pipe(map((res) => res));
  }

  getStudentListForTc(jobId){
    const lang = "en";
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/get/student/details/for/scheduled/job?lang=${lang}&jobDetailId=${jobId}`;
    return this.http.get(url, {headers }).pipe(map((res) => res));
  }
  
}
